
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_bo0ab_97",
  "tools": "awsui_tools_wih1l_bo0ab_106",
  "tools-filtering": "awsui_tools-filtering_wih1l_bo0ab_112",
  "tools-align-right": "awsui_tools-align-right_wih1l_bo0ab_117",
  "tools-pagination": "awsui_tools-pagination_wih1l_bo0ab_121",
  "tools-preferences": "awsui_tools-preferences_wih1l_bo0ab_121",
  "tools-small": "awsui_tools-small_wih1l_bo0ab_127",
  "table": "awsui_table_wih1l_bo0ab_133",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_bo0ab_139",
  "wrapper": "awsui_wrapper_wih1l_bo0ab_143",
  "variant-stacked": "awsui_variant-stacked_wih1l_bo0ab_153",
  "variant-container": "awsui_variant-container_wih1l_bo0ab_153",
  "variant-embedded": "awsui_variant-embedded_wih1l_bo0ab_157",
  "has-header": "awsui_has-header_wih1l_bo0ab_160",
  "has-footer": "awsui_has-footer_wih1l_bo0ab_163",
  "cell-merged": "awsui_cell-merged_wih1l_bo0ab_173",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_bo0ab_177",
  "empty": "awsui_empty_wih1l_bo0ab_192",
  "loading": "awsui_loading_wih1l_bo0ab_196",
  "selection-control": "awsui_selection-control_wih1l_bo0ab_200",
  "selection-control-header": "awsui_selection-control-header_wih1l_bo0ab_207",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_bo0ab_212",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_bo0ab_222",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_bo0ab_225",
  "header-secondary": "awsui_header-secondary_wih1l_bo0ab_229",
  "header-controls": "awsui_header-controls_wih1l_bo0ab_246",
  "divider": "awsui_divider_wih1l_bo0ab_263",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_bo0ab_270",
  "footer": "awsui_footer_wih1l_bo0ab_270",
  "thead-active": "awsui_thead-active_wih1l_bo0ab_279",
  "row": "awsui_row_wih1l_bo0ab_280",
  "row-selected": "awsui_row-selected_wih1l_bo0ab_281"
};
  